"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m5 10.41 7 7 9-9L19.59 7 12 14.59 6.41 9H11V7H3v8h2z"
}), 'CallMissedTwoTone');